import React from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { emptyObject } from 'ui-components/default-props/empty';
import { ReturnStatus } from '../../../../../../enums/return-status';
import { ShipmentHelperService } from '../../../../../../services/shipment-helper-service';
import Global from '../../../../../../store/global-selectors';
import ReadOnlyRateCard from '../../../../rate-card/read-only/read-only-rate-card';
import { ReturnVoidedLabelSection } from '../voided/return-voided-label-section';
import { LabelDetailsActions } from './label-actions/label-details-actions';

const returnRateCardSelector = createSelector(
  (state, { returnFulfillmentId }) =>
    Global.selectEntitiesReturnById(state, {
      fulfillmentId: returnFulfillmentId,
    }) || emptyObject,
  (state) => Global.selectReferenceDatagetServiceReferenceLookup(state),
  (returnFulfillment, serviceReferenceLookup) => {
    const { returnConfiguration, trackingInformation, createdDateTime, returnStatus } = returnFulfillment || emptyObject;

    const { labelProviderId, serviceId } = returnConfiguration || emptyObject;

    const { trackingNumber, url: trackingUrl } = trackingInformation || emptyObject;

    const selectedService = serviceReferenceLookup[serviceId];
    const totalCost = ShipmentHelperService.getTotalCost(returnFulfillment);

    const isVoided = returnStatus === ReturnStatus.Voided.toString();

    return {
      labelProviderId,
      serviceName: selectedService?.name,
      shipDate: createdDateTime,
      totalCost,
      trackingNumber,
      trackingUrl,
      isVoided,
    };
  },
);

export const ReadOnlyRateCardContainer = ({ returnFulfillmentId }) => {
  const { labelProviderId, serviceName, shipDate, totalCost, trackingNumber, trackingUrl, deliveryDate, isVoided } = useSelector((state) =>
    returnRateCardSelector(state, { returnFulfillmentId }),
  );

  return isVoided ? (
    <ReturnVoidedLabelSection
      labelProviderId={labelProviderId}
      serviceName={serviceName}
      trackingNumber={trackingNumber}
      trackingUrl={trackingUrl}
    />
  ) : (
    <ReadOnlyRateCard
      deliveryDate={deliveryDate}
      labelDetailsActions={
        <LabelDetailsActions isVoided={isVoided} returnFulfillmentId={returnFulfillmentId} trackingNumber={trackingNumber} />
      }
      labelProviderId={labelProviderId}
      serviceName={serviceName}
      shipDate={shipDate}
      totalCost={totalCost}
      trackingNumber={trackingNumber}
      trackingUrl={trackingUrl}
    />
  );
};

ReadOnlyRateCardContainer.propTypes = {
  returnFulfillmentId: PropTypes.string.isRequired,
};
